import LawyerLogin from '@app/modules/Auth/LoginPage'
import { IRoute } from '@app/Router/IRoute'

import { getLoginPath } from './paths'

export const routes: IRoute[] = [
  {
    path: getLoginPath(),
    component: LawyerLogin,
    exact: true
  }
]
